export default class Draw {
  constructor() {
    this.ctx = null;
    this.tileSize = 32;
    this.images = {};
    this.createImages();
  }

  createImages() {
    
    // Load all sprite images - using public folder paths for production compatibility
    const spriteDefinitions = {
      // Blocks
      'block_hard': '/sprites/blocks/block_hard.png',
      'block_breakable': '/sprites/blocks/block_breakable.png',
      'block_powerup': '/sprites/blocks/block_powerup.png',
      
      // Bombs
      // 'bomb_normal': '/sprites/bombs/bomb_normal.png',
      'bomb_normal': '/sprites/bombs/bomb_normal.png',
      'bomb_super': '/sprites/bombs/bomb_super.png',
      'bomb_trap': '/sprites/bombs/bomb_trap.png',
      'bomb_fly': '/sprites/bombs/bomb_fly.png',
      'bomb_lazer': '/sprites/bombs/bomb_lazer.png',
      
      // Players
      'player_1': '/sprites/players/player_1.png',
      'player_2': '/sprites/players/player_2.png',
      'player_3': '/sprites/players/player_3.png',
      'player_4': '/sprites/players/player_4.png',
      
      // Portals
      'portal_1': '/sprites/portals/portal_1.png',
      'portal_2': '/sprites/portals/portal_2.png',
      'portal_3': '/sprites/portals/portal_3.png',
      'portal_4': '/sprites/portals/portal_4.png',
      
      // Power-ups (effects that apply immediately or to enemies)
      'powerup_speed': '/sprites/powerups/powerup_speed.png',
      'powerup_life': '/sprites/powerups/powerup_life.png',
      'powerup_freeze': '/sprites/powerups/powerup_freeze.png',
      'powerup_block': '/sprites/powerups/powerup_block.png',
      'powerup_invulnerability': '/sprites/powerups/powerup_invulnerability.png',
      
      // Power-up variants for bombs (when appearing as pickups on the ground)
      'powerup_normal': '/sprites/bombs/bomb_normal.png',
      'powerup_super': '/sprites/bombs/bomb_super.png',
      'powerup_lazer': '/sprites/bombs/bomb_lazer.png',
      'powerup_fly': '/sprites/bombs/bomb_fly.png',
      'powerup_trap': '/sprites/bombs/bomb_trap.png',
      
      // Effects
      'fire': '/sprites/fire.png',
      'ice': '/sprites/ice.png'
    };

    // Load each image
    Object.entries(spriteDefinitions).forEach(([key, src]) => {
      const img = new Image();
      img.onload = () => {
        // console.log(`Loaded sprite: ${key}`);
      };
      img.onerror = () => {
        // console.error(`Failed to load sprite: ${key} from ${src}`);
      };
      img.src = src;
      this.images[key] = img;
    });

    // Keep background color for the board
    this.colors = {
      background: '#fbfbfb' // Light blue background
    };
  }

  clear() {
    if (this.ctx) {
      // Fill background with light blue like classic Bomberman
      this.ctx.fillStyle = this.colors.background;
      this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    }
  }

  // Helper method to draw sprite images
  drawSprite(row, column, spriteKey) {
    if (!this.ctx || !this.images[spriteKey]) return;
    
    const img = this.images[spriteKey];
    const x = column * this.tileSize;
    const y = row * this.tileSize;
    
    // Only draw if image is loaded
    if (img.complete && img.naturalHeight !== 0) {
      this.ctx.drawImage(img, x, y, this.tileSize, this.tileSize);
    }
  }

  bomb({ row, column, type = 'normal' }) {
    this.drawSprite(row, column, `bomb_${type}`);
  }

  powerup({ row, column, type = 'speed' }) {
    this.drawSprite(row, column, `powerup_${type}`);
  }

  fire({ row, column }) {
    this.drawSprite(row, column, 'fire');
  }

  ice({ row, column }) {
    this.drawSprite(row, column, 'ice');
  }

  player({ row, column, skinIndex, debuff, debuffCountdown, label = "", shouldDrawLabel = true }) {
    if (!this.ctx) return;
    
    // Use player sprites (skinIndex is 0-based, but sprites are 1-based)
    const playerNumber = (skinIndex || 0) + 1;
    this.drawSprite(row, column, `player_${playerNumber}`);

    const drawRow = Math.floor(row) <= 0 ? row + 1 : row;
    const drawCol = Math.floor(column) <= 0 ? column + 1 : column >= 21 - 1 ? column : column + 0.5;

    const textX = drawCol * this.tileSize;
    const textY = drawRow * this.tileSize - 2;

    if (debuff !== false) {
      this.ctx.fillStyle = debuff === 'freeze' ? "white" : "red";
      this.ctx.font = '18px Arial';
      this.ctx.strokeText(debuffCountdown, textX, textY - 16);
      this.ctx.fillText(debuffCountdown, textX, textY - 16);
    }

    if (label && shouldDrawLabel) {
      this.ctx.font = '14px Arial';
      this.ctx.textAlign = 'center';
      this.ctx.fillStyle = 'white';
      this.ctx.strokeStyle = 'black';
      this.ctx.lineWidth = 2;

      this.ctx.strokeText(label, textX, textY);
      this.ctx.fillText(label, textX, textY);
    }
  }

  block({ row, column, breakable = false }) {
    if (!this.ctx) return;
    
    const spriteKey = breakable ? 'block_breakable' : 'block_hard';
    this.drawSprite(row, column, spriteKey);
  }

  portal({ row, column, variant }) {
    this.drawSprite(row, column, `portal_${variant}`);
  }
}